export const DEFAULT_ACCEPT = 'application/pdf';
export const RECEIPT_MIME_TYPES = ['application/pdf', 'image/*', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];

export const COMPLETED_THRESHOLD = 98;
export const DEFAULT_VIDEO_MIME_TYPE = 'video/mp4';
export const DEFAULT_AUDIO_MIME_TYPE = 'audio/mpeg';
export const DEFAULT_PERSISTENCE = 'LOCAL';

export const DEFAULT_FILE_INPUT = { files: null, isValid: false, showErrors: false, value: '' };
export const DEFAULT_STRING_INPUT = { isValid: false, showErrors: false, value: '' };
export const DEFAULT_NUMBER_INPUT = { isValid: false, showErrors: false, value: null };
export const DEFAULT_INPUT_CHECK = { isValid: true, value: false };
export const DEFAULT_INPUT_IMAGE = { image: null, isValid: false, showErrors: false, value: '' };

export const EMAIL_REGEXP = /^[-_@',.\\/!:a-zA-Z0-9\s]{2,250}$/;
export const NAME_REGEXP = /^[-a-zA-Z\s]{2,20}$/;
export const TEXT_REGEXP = /^[-_',.\\/!:a-zA-Z0-9\s]{2,500}$/;
export const TOPIC_REGEXP = /^[-_',.:a-zA-Z0-9\s]{10,30}$/;
export const TITLE_REGEXP = /^[-_',.:a-zA-Z0-9\s]{3,30}$/;
export const PASSWORD_REGEXP = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/;
export const BANK_ACCOUNT_REGEXP = /^[a-zA-Z0-9\s]{10,30}$/;
export const HEADLINE_REGEXP = /^[-_',.:a-zA-Z0-9\s]{10,60}$/;
export const PASSWORD_HELPER_TEXT = 'minimum length 8, at least 1 uppercase, 1 lowercase, 1 special character and 1 number';
export const SALARY_REGEXP = /^[0-9]{1,6}$/;
export const CHARGE_HOUR_REGEXP = /^([1-9]|1[0-9]|2[0-4])$/;
export const DOCUMENT_NAME_REGEXP = /^[-_a-zA-Z0-9(). ]{2,50}$/;

export const TOPIC_MAX_LENGTH = 30;
export const TITLE_MAX_LENGTH = 30;
export const HEADLINE_MAX_LENGTH = 60;

export const ACTIVE_ENUM = ['true', 'false'];
export const INFO_EDIT_ROLES = ['Admin', 'Editor'];
export const ALLOWED_THEMES = ['light', 'dark'];

export const UNAUTHORIZED_MESSAGE = 'Unauthorized!';
export const PROFILE_PICTURE_FOLDER = 'profilePictures';
export const TUTORIALS_FOLDER = 'tutorials';
export const DOCUMENTS_FOLDER = 'documents';
export const INTRO_VIDEOS_FOLDER = 'intro';
export const CURRENTLY_WATCHING = 'currentlyWatching';
export const CURRENTLY_WATCHING_INTRO = 'currentlyWatchingIntro';
export const CATEGORIZE_COURSES_KEY = 'categorizeCourses';
export const CATEGORIZE_WISHES_KEY = 'categorizeWishes';
export const COMPLETED = 'completed';
export const NUMBER_OF_VIDEOS = 'numberOfVideos';

export const RETRY_INTERVAL = 250; // amount of time in milliseconds to wait before re0querying firestore for dat;
export const AUTO_LOGOUT_DURATION = 172800000; // 2 days in milliseconds ('1.728e+8';
export const CARD_WIDTH = 250;
export const CARD_MARGIN = 5;
export const DRAWER_WIDTH = 240;
export const MAX_RETRIES = 5;
export const COMING_SOON_MESSAGE = 'Unpublished tutorial. Please check back later!';

export const COUNTRY_DETAILS = [
  { flag: '🇨🇲', id: '+237', locale: 'CM', name: 'CM' },
  { flag: '🇨🇦', id: '+1', locale: 'en-CA', name: 'CA' },
  { flag: '🇪🇪', id: '+372', locale: 'et-EE', name: 'EE' },
  { flag: '🇫🇮', id: '+358', locale: 'fi-FI', name: 'FI' },
  { flag: '🇫🇷', id: '+33', locale: 'fr-FR', name: 'FR' },
  { flag: '🇩🇪', id: '+49', locale: 'de-DE', name: 'DE' },
  { flag: '🇬🇷', id: '+30', locale: 'el-GR', name: 'GR' },
  { flag: '🇭🇺', id: '+36', locale: 'hu-HU', name: 'HU' },
  { flag: '🇮🇹', id: '+39', locale: 'it-IT', name: 'IT' },
  { flag: '🇱🇻', id: '+371', locale: 'lv-LV', name: 'LV' },
  { flag: '🇳🇱', id: '+31', locale: 'nl-NL', name: 'NL' },
  { flag: '🇷🇺', id: '+7', locale: 'ru-RU', name: 'RU' },
  { flag: '🇪🇸', id: '+34', locale: 'es-ES', name: 'ES' },
  { flag: '🇬🇧', id: '+44', locale: 'en-GB', name: 'GB' },
  { flag: '🇺🇸', id: '+1', locale: 'en-US', name: 'US' },
];

export const CURRENCY_CODES = [
  'USD',
  'ANG',
  'GBP',
  'EUR',
  'RSD',
  'SSP',
  'AOA',
  'XCD',
  'ARS',
  'AMD',
  'AWG',
  'AUD',
  'AZN',
  'BHD',
  'BDT',
  'BBD',
  'BYN',
  'BZD',
  'XOF',
  'BMD',
  'BTN',
  'BOB',
  'BAM',
  'BWP',
  'BRL',
  'BND',
  'BGN',
  'BIF',
  'KHR',
  'XAF',
  'CAD',
  'CVE',
  'KYD',
  'CLP',
  'CNY',
  'COP',
  'KMF',
  'CDF',
  'CKD',
  'CRC',
  'HRK',
  'CUP',
  'CZK',
  'DKK',
  'DJF',
  'DOP',
  'EGP',
  'ERN',
  'ETB',
  'FJD',
  'XPF',
  'GMD',
  'GEL',
  'GHS',
  'GIP',
  'GTQ',
  'GNF',
  'GYD',
  'HTG',
  'HNL',
  'HKD',
  'HUF',
  'ISK',
  'INR',
  'IDR',
  'IRR',
  'IQD',
  'ILS',
  'JMD',
  'JPY',
  'JOD',
  'KZT',
  'KES',
  'KPW',
  'KRW',
  'KWD',
  'KGS',
  'LAK',
  'LBP',
  'LSL',
  'LRD',
  'LYD',
  'CHF',
  'MOP',
  'MKD',
  'MGA',
  'MWK',
  'MYR',
  'MVR',
  'MRO',
  'MUR',
  'MXN',
  'MDL',
  'MNT',
  'ALL',
  'MAD',
  'MZN',
  'MMK',
  'NAD',
  'NPR',
  'NZD',
  'NIO',
  'NGN',
  'NOK',
  'OMR',
  'PKR',
  'PAB',
  'PGK',
  'PYG',
  'PEN',
  'PHP',
  'PLN',
  'QAR',
  'RON',
  'RUB',
  'RWF',
  'SHP',
  'WST',
  'STD',
  'SAR',
  'SCR',
  'SLL',
  'SGD',
  'SBD',
  'SOS',
  'ZAR',
  'LKR',
  'SDG',
  'SRD',
  'SZL',
  'SEK',
  'SYP',
  'TWD',
  'TJS',
  'TZS',
  'THB',
  'TOP',
  'TTD',
  'TND',
  'TRY',
  'TMT',
  'UGX',
  'UAH',
  'AED',
  'UYU',
  'UZS',
  'VUV',
  'VEF',
  'VND',
  'YER',
  'ZMW',
  'ZWL',
  'AFN',
  'DZD',
];

// NB: first value of enum arrays are used as defaults
